"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _exenv = require("exenv");
var _includes = _interopRequireDefault(require("lodash/includes"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _queryString = _interopRequireDefault(require("query-string"));
var _tracking = require("@nerdwallet/nw-client-lib/tracking");
var _googleMapsAutocomplete = _interopRequireDefault(require("./google-maps-autocomplete"));
// Dependencies

// Utils

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

// React components

function getInputsToUpdate(place) {
  if (place.address_components) {
    // If an autocomplete suggestion is selected we'll get a address_components object
    // This object is a collection of address components for this Place's location
    // We want go through this collection of information and grab the information we need
    // For example: locality maps to city, postal_code maps to zipCode
    // TODO: can we use @nerdwallet/transform?
    return place.address_components.reduce(function (inputs, input) {
      if ((0, _includes.default)(input.types, 'postal_code')) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, inputs), {}, {
          zipCode: input.long_name
        });
      }
      if ((0, _includes.default)(input.types, 'locality')) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, inputs), {}, {
          city: input.long_name
        });
      }
      if ((0, _includes.default)(input.types, 'administrative_area_level_2')) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, inputs), {}, {
          county: input.long_name
        });
      }
      if ((0, _includes.default)(input.types, 'administrative_area_level_1')) {
        return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, inputs), {}, {
          state: input.short_name
        });
      }
      return inputs;
    }, {});
  }
  return {};
}
function getInputsToClear(inputs) {
  return ['zipCode', 'city', 'county', 'state'].reduce(function (inputIds, inputType) {
    if (!inputs[inputType]) {
      inputIds.push(inputType);
    }
    return inputIds;
  }, []);
}
var RegionsAutocomplete = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(RegionsAutocomplete, _Component);
  var _super = (0, _createSuper2.default)(RegionsAutocomplete);
  function RegionsAutocomplete(props) {
    var _this;
    (0, _classCallCheck2.default)(this, RegionsAutocomplete);
    _this = _super.call(this, props);
    _this.state = {
      validated: props.initialValueValidated,
      value: props.initialValue
    };
    _this.onBlurTimeout = null;
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSelect = _this.onSelect.bind((0, _assertThisInitialized2.default)(_this));
    _this.postBlur = _this.postBlur.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(RegionsAutocomplete, [{
    key: "onBlur",
    value: function onBlur() {
      this.clearOnBlurTimeout();
      if (_exenv.canUseDOM) {
        // There are 2 sequence of events being fired
        // 1. onChange -> onBlur -> wait timeout -> postBlur
        // 2. onChange -> onBlur -> onSelect
        // we want to call postBlur only if onSelect was not fired
        this.onBlurTimeout = window.setTimeout(this.postBlur, 300);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      this.setState({
        value: value,
        validated: false
      });
    }
  }, {
    key: "onFocus",
    value: function onFocus() {
      this.clearOnBlurTimeout();
    }
  }, {
    key: "onSelect",
    value: function onSelect(place) {
      var _this2 = this;
      this.clearOnBlurTimeout();
      var selected = !!place.formatted_address;
      if (this.state.validated && !selected) {
        // if value is validated already and nothing is selected then nothing changed
        // For example: valid input -> focus and press enter -> should not trigger validation
        return;
      }
      var value = place.formatted_address || place.name;
      var inputsToUpdate = getInputsToUpdate(place);
      var inputsToClear = getInputsToClear(inputsToUpdate);
      inputsToUpdate[this.props.inputKey] = !(0, _isEmpty.default)(inputsToUpdate);
      inputsToUpdate.regionsAutocompleteValue = value;
      this.props.onInputChange(inputsToUpdate, inputsToClear).then(function () {
        _this2.trackOnChange(_this2.state.value); // track user input
        _this2.trackOnChange(value); // track user autocomplete select

        _this2.setState({
          value: value,
          validated: true
        });
        _this2.onSubmit();
      });
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      var _this3 = this;
      if (this.props.onInputSubmit) {
        this.props.onInputSubmit().then(function () {
          _this3.trackOnSubmit();
        });
      }
    }
  }, {
    key: "postBlur",
    value: function postBlur() {
      var _this4 = this;
      if (this.state.validated) {
        // if value is validated already then no change
        return;
      }
      var inputsToUpdate = {
        regionsAutocompleteValue: this.state.value
      };
      var inputsToClear = getInputsToClear(inputsToUpdate);
      if (!this.state.value) {
        // if value is empty then revert to default
        inputsToClear.push(this.props.inputKey);
      } else {
        // else value is not empty and autocomplete suggestion not selected
        inputsToUpdate[this.props.inputKey] = false;
      }
      this.props.onInputChange(inputsToUpdate, inputsToClear).then(function () {
        _this4.trackOnChange(_this4.state.value);
        _this4.setState({
          validated: true
        });
        _this4.onSubmit();
      });
    }
  }, {
    key: "trackOnChange",
    value: function trackOnChange(fieldValue) {
      var _this$props$tracking = this.props.tracking,
        enable = _this$props$tracking.enable,
        formName = _this$props$tracking.formName,
        fieldName = _this$props$tracking.fieldName;
      if (enable) {
        (0, _tracking.formInputChanged)({
          formName: formName,
          fieldName: fieldName,
          fieldValue: fieldValue
        });
      }
    }
  }, {
    key: "trackOnSubmit",
    value: function trackOnSubmit() {
      if (this.props.tracking.enable) {
        (0, _tracking.formSubmit)({
          formName: this.props.tracking.formName,
          fieldName: this.props.tracking.fieldName,
          fieldValue: _queryString.default.stringify((0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _omit.default)(this.props.inputs, this.props.sensitiveInputs)), this.props.tracking.additionalData), {
            skipNull: false,
            skipEmptyString: false
          })
        });
      }
    }
  }, {
    key: "clearOnBlurTimeout",
    value: function clearOnBlurTimeout() {
      if (_exenv.canUseDOM && this.onBlurTimeout) {
        clearTimeout(this.onBlurTimeout);
        this.onBlurTimeout = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var props = {
        autocompleteOptions: {
          types: ['(regions)'],
          componentRestrictions: {
            country: ['US']
          }
        },
        enableAutoFocus: this.props.enableAutoFocus,
        enableSelectOnEnter: true,
        onBlur: this.onBlur,
        onChange: this.onChange,
        onFocus: this.onFocus,
        onSelect: this.onSelect,
        placeholder: this.props.placeholder,
        error: this.props.error,
        help: this.props.help,
        value: this.state.value
      };
      return /*#__PURE__*/_react.default.createElement(_googleMapsAutocomplete.default, props);
    }
  }]);
  return RegionsAutocomplete;
}(_react.Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
exports.default = RegionsAutocomplete;
RegionsAutocomplete.displayName = 'RegionsAutocomplete';

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
RegionsAutocomplete.defaultProps = {
  enableAutoFocus: false,
  initialValue: '',
  initialValueValidated: true,
  placeholder: 'Enter a location',
  trackingFormName: 'input',
  sensitiveInputs: [],
  tracking: {
    enable: true,
    formName: 'google-input',
    fieldName: 'regions-autocomplete',
    additionalData: {}
  },
  error: false,
  help: ''
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
RegionsAutocomplete.propTypes = {
  enableAutoFocus: _propTypes.default.bool,
  error: _propTypes.default.bool,
  help: _propTypes.default.string,
  inputs: _propTypes.default.object.isRequired,
  // eslint-disable-line react/forbid-prop-types
  inputKey: _propTypes.default.string.isRequired,
  initialValue: _propTypes.default.string,
  initialValueValidated: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  sensitiveInputs: _propTypes.default.arrayOf(_propTypes.default.number),
  tracking: _propTypes.default.shape({
    enable: _propTypes.default.bool.isRequired,
    formName: _propTypes.default.string,
    fieldName: _propTypes.default.string,
    // eslint-disable-next-line react/forbid-prop-types -- directive added automatically by Shepherd migration
    additionalData: _propTypes.default.object
  }),
  // mapped actions
  onInputChange: _propTypes.default.func.isRequired,
  onInputSubmit: _propTypes.default.func,
  trackingFormName: _propTypes.default.string
};